<template>
  <div class="vouchersGet">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">获取卡券</span>
    </div>
    <div v-if="list.length === 0">
      <van-empty description="暂无可获取卡券" />
    </div>
    <div v-else v-for="item in list" :key="item.id" class="couponListItem">
      <div class="circle leftCircle" />
      <div class="circle rightCircle" />
      <div class="top">
        <div class="right">
          <div class="name">
            <div class="up">
              <span class="value">{{ item.deductionTimes || item.deductionFee }}</span>
              <span class="unit">{{ item.consumeType === 'COST_PER_TIMES' ? '次' : '元' }}</span>
            </div>
            <div class="bottom">
              {{ item.consumeType === 'COST_PER_TIMES' ? '次数抵扣券' : '金额满减券' }}
            </div>
          </div>
          <div class="value">
            <div class="up">{{ item.couponName }}</div>
            <div class="down">
              {{ item.expireDate ? `发放日起${item.expireDays}天内使用` : '不限日期使用' }}
            </div>
          </div>
        </div>
        <div class="left">
          <van-button type="info" size="small" @click="() => onGet(item.id, item.couponName)">申请</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { consumeCoupons } from '@/api/user';
export default {
  name: 'VouchersGet',
  data() {
    return {
      loading: false,
      finished: false,
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'vouchers' });
    },
    getList() {
      consumeCoupons({}).then(res => {
        this.list = res.data;
      });
    },
    onGet(id, name) {
      this.$router.push({ name: 'voucherApplication', query: { id: id, name }});
      this.$store.dispatch('setCouponInfo', { id, name });
    }
  }
};
</script>

<style lang="less" scoped>
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}

.vouchersGet {
  .couponListItem {
    background: #FFFFFF;
    border: 1px solid #EFEFF4;
    box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
    opacity: 1;
    border-radius: 6px;
    position: relative;
    .change_val(margin, 16);
    .circle {
      position: absolute;
      //.change_val(width, 25);
      //.change_val(height, 25);
      width: 6px;
      height: 8px;
      background-color: #efeff4;

    }

    .leftCircle {
      left: -3px;
      .change_val(bottom, 25);
      border-right: 1px solid #3B86FF;
      border-radius: 0 8px 8px 0;
    }

    .rightCircle {
      right: -3px;
      .change_val(bottom, 25);
      border-left: 1px solid #3B86FF;
      border-radius: 8px 0 0 8px;
    }

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 2px solid #3B86FF;
      border-top: 1px solid #3B86FF;
      border-right: 1px solid #3B86FF;
      border-left: 1px solid #3B86FF;
      opacity: 1;

      .change_margin(padding, 22, 38);
      .change_val(padding-bottom, 55);
      .right {
        display: flex;
        .name {
          text-align: center;
          display: flex;
          flex-direction: column;
          border-right: 1px dashed #3B86FF;
          .change_val(padding-right, 32);
          .up {
            .value {
              font-weight: 400;
              //font-size: 44px;
              .change_val(font-size, 44);
              .change_val(line-height, 62);
              color: #3B86FF;
            }

            .unit {
              font-weight: 400;
              //font-size: 20px;
              .change_val(font-size, 20);
              .change_val(line-height, 28);
              .change_val(margin-left, 4);
              color: #3B86FF;
            }
          }

          .bottom {
            .change_val(font-size, 20);
            .change_val(line-height, 28);
            .change_val(margin-left, 4);
            font-weight: 400;
            color: #3B86FF;
            opacity: 1;
          }

        }

        .value {
          .change_val(padding-left, 32);

          .up {
            .change_val(font-size, 32);
            .change_val(line-height, 45);
            font-weight: 400;
            color: #333333;
            opacity: 1;
          }

          .down {
            .change_val(font-size, 20);
            .change_val(line-height, 28);
            .change_val(margin-top, 14);
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
            opacity: 1;
          }
        }
      }
      .left {
        color: #3B86FF;
        .change_val(font-size, 42);
      }
    }

  }
}

</style>
